import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CdkDragDrop, DragDropModule, moveItemInArray} from '@angular/cdk/drag-drop';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgFor, NgIf} from "@angular/common";
import {PlannerRepository} from "../../../repositories/planner.repository";
import {ActivatedRoute} from "@angular/router";
import {STEP_STATUS} from "../../../models/enums";
import {Utilities} from "../../../utilities/utilities";
import {environment} from "../../../../environments/environment";
@Component({
  selector: 'app-initial-plan',
  standalone: true,
  imports: [DragDropModule,ReactiveFormsModule,NgFor,FormsModule,NgIf],
  templateUrl: './initial-plan.component.html',
  styleUrl: './initial-plan.component.css'
})
export class InitialPlanComponent {
  toolingId: string | null = "";
  tempData: string | null = "";
  @Input() step: any;
  @Output() loadTooling: EventEmitter<void> = new EventEmitter<void>();

  constructor(private plannerRepository: PlannerRepository,private route: ActivatedRoute) {}

  async ngOnInit(): Promise<void> {
    this.route.paramMap.subscribe(params => {
      this.toolingId = params.get('plannerId');
    });
    if(environment.standalone){
      this.plannerRepository.setUrl(environment.standaloneServiceUrlForPlanner);
    }
    else {
      this.plannerRepository.setUrl(environment.serviceUrl+environment.plannerServiceUrl);
    }
  }


  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.step.action.planSteps, event.previousIndex, event.currentIndex);
    this.step.action.planSteps[event.currentIndex].seq=event.currentIndex;
    this.step.action.planSteps[event.previousIndex].seq=event.previousIndex;
    console.log(event.previousIndex, event.currentIndex);

  }

  editItem(item: any) {
    this.tempData=item.rawData;
    item.isEditing = true;
  }

  saveItem(item: any,index: any) {
    delete item.isEditing;
  }
  addItem() {
    const newItem = {
      planStepId: "",
      rawData: 'New Item',
      seq: this.step.action.planSteps.length
    };

    this.step.action.planSteps.push(newItem);
  }

  removeItem(index: number) {
    this.step.action.planSteps.splice(index, 1);
  }
  discardEdit(item: any) {
    item.isEditing = false;
    item.rawData = this.tempData;
  }
  next() {
    this.step.stepStatus="USER_FINALIZED";
    if(this.toolingId) {
      this.plannerRepository.patchToolingStep(this.toolingId, this.step.toolingStepId, this.step).subscribe(
        async (toolingStepPatchResponse: any) => {
          this.loadTooling.emit();
        }
      );
    }
  }

  protected readonly STEP_STATUS = STEP_STATUS;
}
